export const ADMIN_ROLE = 'ADMIN';
export const HR_ROLE = 'HR';
export const USER_ROLE = 'USER';
export const JOBS_PER_PAGE = 50;
export const DEFAULT_PAGE = 1;
